import { useCallback } from "react";

import { Action, Context } from "types/generated";
import { AccessResult, NO_ACCESS_MESSAGE } from "utils/access";

const useCanDeleteContext = (): ((context: Context) => AccessResult) => {
  return useCallback((context: Context) => {
    if (context.plugin?.id) {
      return {
        result: false,
        message: `This context is managed by the plugin "${context.plugin.name}" and can't be deleted.`,
      };
    }

    if (context.allowedActions.includes(Action.ContextDelete)) {
      return { result: true };
    }

    return { result: false, message: NO_ACCESS_MESSAGE };
  }, []);
};

export default useCanDeleteContext;
